import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";

function useInventoryProductDetail(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/inventories/product/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryProductDetail;
